module.exports = __webpack_public_path__ + "static/media/ichef_back.a04d78a2.jpg";